<template>
  <div>
      <div class="introduction-toggle"><introduction-toggle ></introduction-toggle></div>
      <introduction></introduction>
      <div class="row relative">
          <div class="col-lg-9 no-padding fixed map">
              <a class="fos--logo" href="http://www.fosopenscouting.be/nl" target="_blank"></a>
              <div class="city-selector-wrapper">
              <city-selector></city-selector>
              </div>
              <div class="entity-map">
                  <map-icon></map-icon>
              </div>
          </div>
          <div class="col-lg-3 no-padding absolute align-right fos--sidebar"><entity-list></entity-list></div>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import MapIcon from '@/components/map/Map.vue'
import EntityList from '@/components/entities/List.vue'
import CitySelector from '@/components/cities/Selector.vue'
import Introduction from '@/components/introduction/Modal.vue'
import IntroductionToggle from '@/components/introduction/Toggle.vue'

export default {
  name: 'home',
  components: {
    MapIcon,
    EntityList,
    CitySelector,
    Introduction,
    IntroductionToggle
  }
}
</script>

<style scoped>

.map {
    background-color: #6bbca6;
    height: auto;
    padding-top: 130px;
}

.fos--sidebar {
    background-color: white;
    padding: 0;
}

.map select {
    background: #fff url('../assets/images/select-arrow.svg') right 10px center no-repeat;
    background-size: 10px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 7px 35px 7px 15px;
    z-index: 50;
    font-family: 'AndesExtraBold', Helvetica, Arial, sans-serif;
    border: 0;
    z-index: 30;
}

.map .city-selector-wrapper {
    position: absolute;
    left: 125px;
    top: 40px;
    height: 34px;
    display: inline-block;
    z-index: 500;
}

.map .city-selector-wrapper::before {
    content: "";
    height: 34px;
    display: inline-block;
    width: 6px;
    background: url('../assets/images/arrow-left.svg') left center no-repeat;
    pointer-events: none;
}

.fos--logo {
    background: url('../assets/images/logo.svg');
    background-repeat: no-repeat;
    display: inline-block;
    width: 80px;
    height: 80px;
    background-size: contain;
    position: absolute;
    left: 20px;
    top: 20px;
}

.introduction-toggle button {
    background-color: transparent;
    border: 0;
    color: black;
    z-index: 2;
    text-indent: -9999px;
    width: 50px;
    height: 50px;
}

.introduction-toggle {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 2;
}

@media all and (min-width: 992px) {
    .fos--logo {
        position: fixed;
        width: 140px;
        height: 140px;
    }

    .map {
        height: 100%;
        padding-top: 0;
    }

    .map .city-selector-wrapper {
        position: fixed;
        left: 180px;
        top: 72px;
    }

    .introduction-toggle button {
        text-indent: -9999px;
        width: 50px;
        height: 50px;
    }

    .introduction-toggle {
        position: fixed;
        bottom: 30px;
        top: unset;
        right: unset;
        left: 30px;
        z-index: 2;
    }
}

@media all and (min-width: 992px) {
    .entity-map {
        position: relative;
        margin: 60px;
    }

    .entity-map svg {
        max-width: 100%;
        max-height: calc(100vh - 120px);
    }
}

</style>


// WEBPACK FOOTER //
// src/views/Home.vue